import React from "react";
import MediaBreakpoints from "Utils/MediaBreakpoints";
import classNames from "classnames";
import { renderItemQty } from "HelperFunctions/rentals";
import { Items } from "Utils/SvgIcons";
import Imgix from "react-imgix";
import CurrencyLabel from "Utils/CurrencyLabel";
import { sanitizedData } from "HelperFunctions/sanitizeData";
import ItemNotesModal from "../ItemNotesModal";

class RentalBundleItem extends React.Component {
  renderInventoryPrice = () => {
    const { item, bundle, bundlePeriod, hideSubtotalPricing } = this.props;

    if (hideSubtotalPricing) {
      return null;
    }
    const inventoryType = item.productType;

    let price;
    if (inventoryType === "items") {
      if (bundlePeriod !== "editedFlatUnitPrice") {
        price = item.product[bundlePeriod];
        if (!price) {
          price = item.selectedPrice / item.quantity;
        }
      } else {
        price = item.selectedPrice;
      }
    } else if (inventoryType === "addons") {
      price = item.selectedPrice;
    } else {
      price = 0;
    }

    if (Number(price) === 0) {
      return "N/A";
    } else {
      return (
        <CurrencyLabel
          value={price * (1 - Number(bundle.discountPercent))}
        />
      );
    }
  };

  render() {
    const {
      item,
      bundle,
      tileView,
      showUnitPricingToCustomers,
      hideSubtotalPricing,
      showItemNotes,
      showImageCol,
      showRateCol,
      showFeesCol,
      showDiscountsCol,
    } = this.props;
    const { name, hasShortage, thumbnailUrl, imgixUrl } = item;
    const mobileImageUrl = imgixUrl || thumbnailUrl;
    const hasMobileImage = Boolean(tileView && mobileImageUrl);
    const itemNotesVisibleToCustomer = item.itemNotes.filter(itemNote => itemNote.shouldIncludeNotesInRentals);
    // Mobile line values reuse the same gates/logic as the desktop cells.
    const priceLine =
      showUnitPricingToCustomers && !bundle.priceLocked
        ? this.renderInventoryPrice()
        : null;
    const subtotalLine = hideSubtotalPricing
      ? null
      : item.selectedPrice === 0
        ? "N/A"
        : <CurrencyLabel value={item.selectedPrice || 0} />;

    return (
      <MediaBreakpoints
        desktop={
          // Sub-item row lives in the parent grid table. Cells are emitted 1:1
          // with the parent columns (gated by the same showImageCol/showRateCol/
          // showFeesCol/showDiscountsCol the header uses) so everything lines up;
          // only the CONTENT keeps the existing per-item display logic.
          <tbody className="bundleSubItem">
            <tr>
              {showImageCol && <td className="image" />}
              <td className="normalText indent">
                {name}
                {showItemNotes && itemNotesVisibleToCustomer?.map(
                  (itemNote, idx) => <span
                    key={itemNote.id ?? idx}
                    className="caption editedText"
                    style={{ display: "block" }}
                    dangerouslySetInnerHTML={sanitizedData(itemNote.message)}
                  />)}
              </td>
              <td
                className={classNames({
                  right: true,
                  alert: hasShortage
                })}
              >
                {renderItemQty(item)}
              </td>
              {showRateCol && (
                <td className="medSm right">
                  {!bundle.priceLocked && this.renderInventoryPrice()}
                </td>
              )}
              {showFeesCol && <td className="medSm right" />}
              {showDiscountsCol && <td className="medSm right" />}
              <td className="medSm right">
                {hideSubtotalPricing ? null : item.selectedPrice === 0 ? (
                  "N/A"
                ) : (
                  <CurrencyLabel value={item.selectedPrice || 0} />
                )}
              </td>
            </tr>
          </tbody>
        }
        mobile={
          <tbody className="mobileItemContent">
            {/* Mobile: only render an image when one exists, full-width. */}
            {hasMobileImage && (
              <tr>
                <td colSpan="3">
                  <figure className="mobileFullImage">
                    <Imgix
                      src={mobileImageUrl}
                      alt={name}
                      width={600}
                    />
                  </figure>
                </td>
              </tr>
            )}
            <tr className="noBorder">
              <td
                colSpan="3"
                className={classNames({
                  alert: hasShortage
                })}
              >
                {name}
                {/* Stacked labeled lines instead of columns on mobile, matching
                    the RentalItem mobile line pattern (.caption.lineDetails). */}
                <div className="caption lineDetails">
                  <div>
                    <strong>Quantity</strong> {renderItemQty(item)}
                  </div>
                  {priceLine != null && (
                    <div>
                      <strong>Price</strong> {priceLine}
                    </div>
                  )}
                  {subtotalLine != null && (
                    <div>
                      <strong>Subtotal</strong> {subtotalLine}
                    </div>
                  )}
                </div>
                {/* Rich-text notes live in a modal on mobile (TD1-10310). */}
                {showItemNotes && (
                  <ItemNotesModal
                    itemName={name}
                    itemNotes={itemNotesVisibleToCustomer}
                  />
                )}
              </td>
            </tr>
          </tbody>
        }
      />
    );
  }
}

export default RentalBundleItem;
